import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {Utilisateur} from '../../../class/api/Utilisateur';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {HydraService} from '../../../core/services/hydra.service';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {api} from '../../../api/api-dictionnary';
import {Subscription} from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { LowerCasePipe, UpperCasePipe } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-selection-user',
    templateUrl: './modal-selection-user.component.html',
    styleUrls: ['./modal-selection-user.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatIcon, FormsModule, MatIconButton, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatTooltip, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, MatDialogActions, MatDialogClose, LowerCasePipe, TranslateModule, UpperCasePipe]
})
export class ModalSelectionUserComponent implements OnInit {
    data = inject<{
    modalTitle?: string;
    columns?: string[];
    apiEndPoint?: string;
    queryString?: string;
}>(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalSelectionUserComponent>>(MatDialogRef);
    private hydraService = inject(HydraService);


    public subscriptions: Subscription[] = [];
    public selectedSort = null;
    public search = '';
    public _timeout = null;

    public tableColumns: string[];
    public pageSizeOptions = [10,20,30,50,100];
    public total = 0;
    public utilisateurs = new MatTableDataSource<Utilisateur>([]);
    @ViewChild(MatSort, {static: false}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor() {
      const data = this.data;

      this.tableColumns = data.columns ??  ['nom', 'email', 'action'];
  }

    public getCollection(url) {
        this.subscriptions.push(
            this.hydraService.getList(url).subscribe((res: HydraCollection) => {
                this.total = +res['hydra:totalItems'];
                this.utilisateurs.data = res.getMember();

            })
        );
    }

    public getSearchIfExist() {
        return this.search != null && this.search.length ? this.search : null;
    }

    public construcUrlCollection(search = null) {
        let url = this.data.apiEndPoint ?? api.utilisateur;

        const wantPage = this.paginator.pageIndex + 1 ;
        url += `?page=${wantPage}&itemsPerPage=${this.paginator.pageSize}`;

        if (search) {url += '&search=' + search;}
        if (this.selectedSort && this.selectedSort.active && this.selectedSort.direction) {
            url += '&order[' + this.selectedSort.active + ']=' + this.selectedSort.direction;
        } else {
            url += '&order[nom]=asc';
        }

        const queryString = this.data?.queryString;
        if(queryString){
            url += '&' + queryString;
        }

        return url;
    }

    public onChangeResearch(event) {
        if (this._timeout) {
            //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;
            this.selectedSort = null;
            this.refreshFilters();
        }, 500);
    }

    public compareByValue(itemOne, itemTwo) {
        return itemOne == itemTwo;
    }

    submitWithSelection(responsable) {
        this.dialogRef.close(responsable);
    }

    ngOnInit() {
        this.paginator.pageSize = 10;

        this.getCollection(this.construcUrlCollection());
    }

    private refreshFilters() {
        this.reinitPagerParams();
        this.getCollection(this.construcUrlCollection(this.getSearchIfExist()));
    }

    public changeSort(event: {active: string;direction: string}){

        if (event) {
            this.selectedSort = event;
            this.refreshFilters();
        }
        return false;
    }

    public onPaginatorPageChange() {
        this.getCollection(
            this.construcUrlCollection(
                this.getSearchIfExist()
            )
        );
    }

    private reinitPagerParams() {
        this.paginator.pageIndex = 0;
    }


}
